<template>
    <div class='main'>
        <el-tabs v-model='activeName'>
            <el-tab-pane label='数据' name='data'>
                <div class='plugins-tips'>
                    <el-button-group>
                        <el-button icon='el-icon-refresh' size='mini' @click='resetQuery'>重置</el-button>
                        <el-button icon='el-icon-search' size='mini' type='primary' @click='handleQuery'>查询条件
                        </el-button>
                        <el-button icon='el-icon-view' size='mini' @click='handleOpenFieldVisibleSetting'>显示字段
                        </el-button>
                    </el-button-group>
                    
                    <el-button-group style='margin-left: 1rem'>
                        <el-button
                            plain
                            icon='el-icon-plus'
                            size='mini'
                            @click='handleAdd'
                        >新增行
                        </el-button>
                        
                        <el-button
                            type='primary'
                            plain
                            icon='el-icon-plus'
                            size='mini'
                            @click='handleAddColumn'
                        >新增列
                        </el-button>
                    </el-button-group>
                    
                    <el-button style='margin-left: 1rem' v-if='multiSelectIdList.length > 0' type='danger'
                               icon='el-icon-delete' size='mini'
                               @click='handleBatchDelete'>批量删除
                    </el-button>
                    
                    <span
                        style='float: right; color: #409EFF; font-size: 16px;'>Total&nbsp;{{ queryParams.resultTotal }}</span>
                </div>
                
                <el-table v-loading='loading' :cell-style="{ textAlign: 'center' }" :data='classDataList'
                          @sort-change='handleSortChange'
                          @selection-change='handleSelectionChange'
                          @row-click='clickRow'
                          @row-dblclick='dblClickRow'
                >
                    <el-table-column align='center' type='selection' width='55' />
                    
                    
                    <el-table-column label='objectId' prop='objectId' min-width='150' fixed sortable='custom'
                                     align='center'>
                        <template slot='header' slot-scope='scope'>
                            <span class='fieldName'>objectId</span>
                            <span class='fieldType'>String</span>
                        </template>
                        
                        <template slot-scope='scope'>
                            <span style='color: #409EFF; cursor: pointer'>{{ scope.row['objectId'] }}</span>
                        </template>
                    </el-table-column>
                    
                    <el-table-column label='ACL' prop='ACL' width='200' align='center'>
                        <template slot='header' slot-scope='scope'>
                            <span class='fieldName'>ACL</span>
                            <span class='fieldType'>ACL</span>
                        </template>
                        
                        <template slot-scope='scope'>
                            <div class='lineFlex'>
                                <span class='classValue'>{{ computeClassACL(scope.row['ACL']) }}</span>
                                <span class='el-icon-edit-outline'
                                      @click='handleSetDataACL(scope.row)'
                                      style='cursor: pointer;margin-right: .5rem;' />
                            </div>
                        </template>
                    </el-table-column>
                    
                    <el-table-column width='200' v-for='value in visibleCustomFieldTypeMap'
                                     :sortable='computeSortableValue(value)'
                                     :key='value[0]'
                                     align='center' :label='value[0]' :prop='value[0]'>
                        <template slot='header' slot-scope='scope'>
                            <span @click.stop='handleEditColumn(value[0])' class='el-icon-edit-outline'
                                  style='cursor: pointer;margin-right: .5rem;' />
                            <span class='fieldName'>{{ value[0] }}</span>
                            <span class='fieldType'>{{ value[1]['type'] }}</span>
                        </template>
                        
                        <template slot-scope='scope'>
                            <span class='classValue'>{{ scope.row[value[0]] }}</span>
                        </template>
                    </el-table-column>
                    
                    <el-table-column width='150' align='center' v-if='versionEnableStatus' label='_version'
                                     prop='_version'>
                        <template slot='header' slot-scope='scope'>
                            <span class='el-icon-edit-outline'
                                  style='cursor: pointer;margin-right: .5rem;' />
                            <span class='fieldName'>_version</span>
                            <span class='fieldType'>Number</span>
                        </template>
                        
                        <template slot-scope='scope'>
                            <span class='classValue'>{{ scope.row['_version'] }}</span>
                        </template>
                    </el-table-column>
                    
                    <el-table-column width='150' prop='createUserId' label='createUserId' align='center'>
                        <template slot='header' slot-scope='scope'>
                            <span class='fieldName'>createUserId</span>
                            <span class='fieldType'>String</span>
                        </template>
                        
                        <template slot-scope='scope'>
                            <span @click='handleShowUserInfo(scope.row["createUserId"])'
                                  style='color: #409EFF; cursor: pointer'
                                  class='classValue'>{{ scope.row['createUserId'] }}</span>
                        </template>
                    </el-table-column>
                    
                    <el-table-column width='150' prop='updateUserId' label='updateUserId' align='center'>
                        <template slot='header' slot-scope='scope'>
                            <span class='fieldName'>updateUserId</span>
                            <span class='fieldType'>String</span>
                        </template>
                        
                        <template slot-scope='scope'>
                            <span @click='handleShowUserInfo(scope.row["updateUserId"])'
                                  style='color: #409EFF; cursor: pointer'
                                  class='classValue'>{{ scope.row['updateUserId'] }}</span>
                        </template>
                    </el-table-column>
                    
                    <el-table-column min-width='150' prop='createdAt' sortable='custom' label='createdAt'
                                     align='center'>
                        <template slot='header' slot-scope='scope'>
                            <span class='fieldName'>createdAt</span>
                            <span class='fieldType'>Date</span>
                        </template>
                        
                        <template slot-scope='scope'>
                            <span>{{ scope.row['createdAt'] }}</span>
                        </template>
                    </el-table-column>
                    
                    <el-table-column min-width='150' prop='updatedAt' sortable='custom' label='updatedAt'
                                     align='center'>
                        <template slot='header' slot-scope='scope'>
                            <span class='fieldName'>updatedAt</span>
                            <span class='fieldType'>Date</span>
                        </template>
                        
                        <template slot-scope='scope'>
                            <span>{{ scope.row['updatedAt'] }}</span>
                        </template>
                    </el-table-column>
                    
                    <el-table-column fixed='right' align='center' width='200' class-name='small-padding fixed-width'
                                     label='操作'>
                        <template slot-scope='scope'>
                            <el-button
                                icon='el-icon-delete'
                                size='mini'
                                type='text'
                                @click='handleDelete(scope.row)'
                            >删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                
                <div class='pagination'>
                    <el-pagination
                        :current-page='queryParams.pageNum'
                        :page-sizes='[15, 30, 45, 60, 75, 100]'
                        :page-size='queryParams.pageSize'
                        :total='queryParams.resultTotal'
                        background
                        layout='sizes, prev, pager, next'
                        @size-change='handleSizeChange'
                        @current-change='handlePagination'>
                    </el-pagination>
                </div>
            </el-tab-pane>
            <el-tab-pane label='权限' name='permission'>
                <data-permission-setting :app-id='queryParams.appId'
                                         :class-name='queryParams.className' />
            </el-tab-pane>
            <el-tab-pane label='性能与索引' name='index'>
            
            </el-tab-pane>
            <el-tab-pane label='慢执行日志' name='slowlyExecute'>
                <slow-execute-log :app-id='queryParams.appId' :class-name='queryParams.className' />
            </el-tab-pane>
            <el-tab-pane label='其他' name='other'>
                <el-card v-if='queryParams.className !== "_User" && queryParams.className !== "_Role"' class='box-card'
                         shadow='never'>
                    <el-link style='margin-bottom: .5rem;' type='primary' target='_blank'
                             :href='`http://8.130.32.232:6500/a/grafana-lokiexplore-app/explore/service/cloud-storage/logs?var-filters= service_name|=|cloud-storage&var-lineFilters=caseInsensitive,0|__gfp__=|${queryParams.className}`'>
                        查看{{ queryParams.className }}请求日志
                    </el-link>
                    <el-divider></el-divider>
                    <div>
                        <el-alert
                            style='margin-bottom: 1rem;'
                            :closable='false'
                            :title='`你如果需要删除${queryParams.className}，需要保证该Class内无任何数据。Class被删除之后，可以被再次创建`'
                            type='warning'>
                        </el-alert>
                        
                        <el-popconfirm
                            @confirm='handleConfirmDeleteClass'
                            :title='`确定删除${queryParams.className}?`'
                        >
                            <el-button size='mini' slot='reference'>删除{{ queryParams.className }}</el-button>
                        </el-popconfirm>
                    </div>
                    
                    <div>
                        <el-switch
                            style='margin-top: 1rem;'
                            v-model='versionEnableStatus'
                            @change='handleVersionChange'
                            active-text='启用版本号机制'
                            inactive-text='关闭版本号机制'>
                        </el-switch>
                    </div>
                </el-card>
            </el-tab-pane>
        </el-tabs>
        
        <!-- 添加或修改用户配置对话框 -->
        <el-dialog :title='title' :visible.sync='open' width='40%' @close='cancel'>
            
            <div slot='footer' class='dialog-footer'>
                <el-button type='primary' @click='submitForm'>保 存</el-button>
                <el-button @click='cancel'>取 消</el-button>
            </div>
        </el-dialog>
        
        <el-dialog title='详细数据' :close-on-click-modal='true' :close-on-press-escape='true' :show-close='false'
                   :visible.sync='openClassDataDetail' width='40%'>
            <vue-json-pretty :data='currentClassDataInfo' />
        </el-dialog>
        
        <el-dialog title='字段编辑修改' :show-close='true'
                   :visible.sync='openClassDataEdit' width='40%'>
            <el-descriptions class='margin-top' :column='1' direction='vertical'>
                <el-descriptions-item :label='currentClassEditInfo.columnName'>
                    <class-edit :key='computeComponentKey(new Date().getTime())' :data-name='computeComponentKey(new Date().getTime())'
                                :origin-value='currentClassEditInfo.value'
                                @getNewClassValue='getEditedColumnValue'
                                :type='currentClassEditInfo.fileOption.type' />
                </el-descriptions-item>
            </el-descriptions>
            
            <div slot='footer' class='dialog-footer'>
                <el-button type='primary' @click='executeUpdateSubmit'>保 存</el-button>
                <el-button @click='executeUpdateCancel'>取 消</el-button>
            </div>
        </el-dialog>
        
        <el-dialog :title='`批量删除 ${multiSelectIdList.length} 行数据`'
                   :visible.sync='openBatchDeleteData' width='40%'>
            <el-alert
                title='此操作不可逆，数据被删除之后，无法找回！'
                :closable='false'
                type='error'>
            </el-alert>
            
            <div slot='footer' class='dialog-footer'>
                <el-button type='primary' @click='executeBatchDelete'>执 行</el-button>
                <el-button @click='openBatchDeleteData = false'>取 消</el-button>
            </div>
        </el-dialog>
        
        <el-dialog title='查询' :show-close='false'
                   :visible.sync='openConditionQuery' width='40%'>
            <class-filter :all-type='queryFieldType' @getFilterCondition='handleGetFilterCondition'>
                <el-button type='primary' @click='openConditionQuery = false'>关 闭</el-button>
            </class-filter>
        </el-dialog>
        
        <el-dialog title='显示字段' :show-close='true'
                   :visible.sync='openFieldVisibleSetting' width='40%'>
            <div class='fieldVisibleToolbar'>
                <el-button size='mini' @click='handleSelectAllVisibleField'>全选</el-button>
                <el-button size='mini' @click='handleInvertVisibleField'>反选</el-button>
                <el-button size='mini' @click='handleClearVisibleField'>清空</el-button>
            </div>
            <el-checkbox-group v-model='visibleCustomFieldNameList' class='fieldVisibleGroup'>
                <el-checkbox
                    v-for='value in customFieldTypeMap'
                    :key='value[0]'
                    :label='value[0]'
                    class='fieldVisibleItem'>
                    <span class='fieldName'>{{ value[0] }}</span>
                    <span class='fieldType'>{{ value[1]['type'] }}</span>
                    <span v-if='value[1]["description"]' class='fieldDescription'>{{ value[1]['description'] }}</span>
                </el-checkbox>
            </el-checkbox-group>
            
            <div slot='footer' class='dialog-footer'>
                <el-button type='primary' @click='openFieldVisibleSetting = false'>关 闭</el-button>
            </div>
        </el-dialog>
        
        <el-dialog title='新增数据' :show-close='true'
                   :visible.sync='openAddData' width='40%'>
            <el-form label-position='top'>
                <el-form-item :prop='value[0]' :label='value[0]'
                              v-if='value[1]["require"] && value[1]["require"] === true'
                              v-for='(value, index) in customFieldTypeMap' :key='index'>
                    <class-edit @getNewClassValue='handleGetAddDataFieldValue($event, value[0])'
                                :type='value[1].type'
                                :key='new Date().getTime()'
                                :textarea-row-info='{ minRows: 1, maxRows: 5 }' />
                </el-form-item>
                <el-divider>非必须参数</el-divider>
                <el-form-item :prop='value[0]' :label='value[0]'
                              v-if='!value[1]["require"] || value[1]["require"] === false'
                              v-for='(value, index) in customFieldTypeMap' :key='index'>
                    <class-edit @getNewClassValue='handleGetAddDataFieldValue($event, value[0])'
                                :type='value[1].type'
                                :key='new Date().getTime()'
                                :textarea-row-info='{ minRows: 1, maxRows: 5 }' />
                </el-form-item>
            </el-form>
            
            <el-collapse>
                <el-collapse-item title='设置ACL' name='1'>
                    <class-acl :app-id='queryParams.appId'
                               :show-authenticated-user-setting='false'
                               :show-button-group='false'
                               :key='new Date().getTime()'
                               @getAccessInfo='handleSetAddDataACL'
                               :all-access-info='currentSelectDataInfo.addACL' />
                </el-collapse-item>
            </el-collapse>
            <div slot='footer' class='dialog-footer'>
                <el-button type='primary' @click='executeAddData'>保 存</el-button>
                <el-button @click='openAddData = false'>取 消</el-button>
            </div>
        </el-dialog>
        
        <el-dialog title='列增加或编辑' :show-close='false'
                   :visible.sync='openColumnEdit' width='40%'>
            <el-form label-position='left'>
                <el-form-item label='类型'>
                    <el-tooltip v-if='!addColumnStatus' class="item" effect="dark" content="只支持将Any类型改为其他类型,如果需要强制修改类型,请先删除字段, 然后再重新创建该字段" placement="top">
                        <span class='el-icon-warning-outline' style='font-size: 12px;color: #F56C6C'>  </span>
                    </el-tooltip>
                    &nbsp;
                    <el-select v-model='currentActiveColumnInfo.type'
                               placeholder='请选择字段类型'>
                        <el-option
                            v-for='item in fieldTypeOption'
                            :key='item.value'
                            :label='item.value'
                            :value='item.value'>
                        </el-option>
                    </el-select>
                </el-form-item>
                
                <el-form-item :label='addColumnStatus ? "字段名" : "字段名【支持重命名】"'>
                    <el-input v-model='currentActiveColumnInfo.editFieldName' size='mini' />
                </el-form-item>
                <el-form-item label='默认值' :key='new Date().getTime()'>
                    <class-edit :origin-value='currentActiveColumnInfo.defaultValue'
                                :textarea-row-info='{ minRows: 5, maxRows: 10 }'
                                @getNewClassValue='handleGetColumnDefaultValue'
                                :type='currentActiveColumnInfo.type' />
                    <div style='margin-top: 1rem;'>
                        <el-button size='mini' style='float: right' @click='handleRemoveDefaultValue' type='primary'
                                   plain>移除默认值
                        </el-button>
                    </div>
                </el-form-item>
                <el-form-item label='是否必须'>
                    <el-switch v-model='currentActiveColumnInfo.required' />
                </el-form-item>
                
                <el-form-item label='字段描述'>
                    <el-input type='textarea' v-model='currentActiveColumnInfo.description' size='mini'
                              :autosize='{ minRows: 5, maxRows: 5 }' />
                </el-form-item>
            </el-form>
            <div slot='footer' class='dialog-footer'>
                <el-button v-if='!addColumnStatus' style='float: left' type='danger' @click='handleDeleteColumn'>删除字段</el-button>
                <el-button type='primary' @click='handleCreateColumn'>保 存</el-button>
                <el-button @click='openColumnEdit = false'>取 消</el-button>
            </div>
        </el-dialog>
        
        <el-dialog :title='`设置${currentClassDataInfo.objectId} ACL`' :show-close='true'
                   :visible.sync='openSetDataACL' width='40%'>
            
            <class-acl :app-id='queryParams.appId'
                       :show-authenticated-user-setting='false'
                       :show-button-group='false'
                       :key='new Date().getTime()'
                       @getAccessInfo='handleGetDataACL'
                       :all-access-info='currentSetDataACL' />
            <div slot='footer' class='dialog-footer'>
                <el-button type='primary' @click='executeUpdateDataACL'>保 存</el-button>
                <el-button @click='openSetDataACL = false'>取 消</el-button>
            </div>
        </el-dialog>
        
        <el-dialog title='用户信息' :close-on-click-modal='true' :close-on-press-escape='true' :show-close='false'
                   :visible.sync='openShowUserInfo' width='40%'>
            <vue-json-pretty :data='currentShowUserInfo' />
        </el-dialog>
    </div>
</template>

<script>

import { pageUtil } from '@/utils/pageUtil';
import { message } from '@/utils/message';
import TrackEventChart from '@view/track/analyse/component/TrackEventChart.vue';
import { storageClassApi } from '@api/Storage/storageClass';
import { storageSchemaApi } from '@api/Storage/storageSchema';
import VueJsonPretty from 'vue-json-pretty';
import ClassEdit from '@/components/component/storage/ClassEdit.vue';
import { deepCopy } from '@/utils/object';
import { applicationCredentialApi } from '@api/Storage/applicaitonCredentialConfig';
import ClassACL from '@/components/component/storage/ClassAcl.vue';
import ClassAcl from '@/components/component/storage/ClassAcl.vue';
import DataPermissionSetting from '@view/storage/manage/component/DataPermissionSetting.vue';
import ClassFilter from '@/components/component/storage/ClassFilter.vue';
import { packageACLInfo, packageACLParam } from '@/utils/storage';
import SlowExecuteLog from '@view/storage/manage/component/SlowlyExecuteLog.vue';
import { storageOperateUserApi } from '@api/Storage/storageUser';
import { storageRoleApi } from '@api/Storage/storageRole';
import { cottonUserApi } from '@api/Account/userCotton';
import { confirm } from '@/utils/confirm';

export default {
    name: 'User',
    components: {
        SlowExecuteLog,
        ClassFilter,
        DataPermissionSetting,
        ClassAcl,
        ClassACL,
        ClassEdit,
        VueJsonPretty,
        TrackEventChart
    },
    data() {
        return {
            // 遮罩层
            loading: true,
            // 选中数组
            multiSelectIdList: [],
            // 总条数
            total: 0,
            // 弹出层标题
            title: '',
            updateStatus: false,
            // 是否显示弹出层
            open: false,
            openClassDataDetail: false,
            openClassDataEdit: false,
            openBatchDeleteData: false,
            openConditionQuery: false,
            openAddData: false,
            openColumnEdit: false,
            addColumnStatus: false,
            openSetDataACL: false,
            openShowUserInfo: false,
            openFieldVisibleSetting: false,
            
            // 查询参数
            queryParams: {
                count: true,
                sortSqlList: undefined,
                order: undefined,
                skip: 0,
                limit: 15,
                pageSize: 15,
                pageNum: 1,
                resultTotal: undefined,
                excludeKeys: undefined,
                where: undefined,
                appId: undefined,
                className: undefined
            },
            classDataList: [],
            schemaInfo: {},
            customFieldTypeMap: new Map,
            visibleCustomFieldNameList: [],
            hasInitVisibleCustomField: false,
            visibleCustomFieldIdentity: undefined,
            allFieldType: {},
            sortableTypeSet: new Set,
            currentClassDataInfo: {},
            currentClassEditInfo: {
                fileOption: {},
                value: undefined,
                columnName: undefined
            },
            
            baseFieldNameList: ['objectId', 'ACL', 'createUserId', 'updateUserId', 'createdAt', 'updatedAt'],
            activeName: 'data',
            isUseMasterKeyMode: false,
            
            applicationConfig: {},
            
            currentAccessInfo: {
                allAccessInfo: {},
                permissionList: []
            },
            updateCLPStatus: false,
            queryFieldType: {},
            currentSelectDataInfo: {
                addACL: {
                    read: {},
                    write: {}
                },
                ACL: {}
            },
            currentActiveColumnInfo: {},
            fieldTypeOption: [
                {
                    value: 'String'
                },
                {
                    value: 'Number',
                },
                {
                    value: 'Boolean',
                },
                {
                    value: 'Date',
                },
                {
                    value: 'Array',
                },
                {
                    value: 'Object'
                },
                {
                    value: 'Pointer'
                },
                {
                    value: 'Any'
                }
            ],
            defaultACL: {
                setDefaultACL: {},
                systemDefaultACL: {
                    '*': {
                        read: true,
                        write: true
                    }
                }
            },
            currentSetDataACL: {},
            classApiMapping: {
                _User: {
                    update: storageOperateUserApi.updateInfo,
                    create: storageOperateUserApi.register,
                    delete: storageOperateUserApi.deleteUser,
                    queryList: storageOperateUserApi.queryList,
                    queryByObjectId: storageOperateUserApi.queryById
                },
                _Role: {
                    update: storageRoleApi.updateRole,
                    create: storageRoleApi.createRole,
                    delete: storageRoleApi.deleteRole,
                    queryList: storageRoleApi.queryRoleList,
                    queryByObjectId: storageRoleApi.queryRoleByObjectId
                },
                other: {
                    update: storageClassApi.updateClass,
                    create: storageClassApi.createClass,
                    delete: storageClassApi.deleteClass,
                    queryList: storageClassApi.queryClassList,
                    queryByObjectId: storageClassApi.queryClassByObjectId
                }
            },
            apiFunction: {
                update: (objectId, data, appId, className) => {
                    let api = this.classApiMapping[className];
                    if (!api) {
                        api = this.classApiMapping.other;
                    }
                    return api.update(objectId, data, appId, className);
                },
                create: (data, appId, className) => {
                    let api = this.classApiMapping[className];
                    if (!api) {
                        api = this.classApiMapping.other;
                    }
                    return api.create(data, appId, className);
                },
                delete: (objectId, appId, className) => {
                    let api = this.classApiMapping[className];
                    if (!api) {
                        api = this.classApiMapping.other;
                    }
                    return api.delete(objectId, appId, className);
                },
                queryList: (data, appId, className) => {
                    let api = this.classApiMapping[className];
                    if (!api) {
                        api = this.classApiMapping.other;
                    }
                    return api.queryList(data, appId, className);
                },
                queryByObjectId: (objectId, appId, className) => {
                    let api = this.classApiMapping[className];
                    if (!api) {
                        api = this.classApiMapping.other;
                    }
                    return api.queryByObjectId(objectId, appId, className);
                }
            },
            currentShowUserInfo: {},
            
            versionEnableStatus: false
        };
    },
    computed: {
        computeClassACL() {
            return classACL => {
                if (!classACL) {
                    if (!this.defaultACL.setDefaultACL) {
                        return this.defaultACL.systemDefaultACL;
                    } else {
                        return this.defaultACL.setDefaultACL;
                    }
                } else {
                    return classACL;
                }
            };
        },
        computeDisableSelectColumnType() {
            if (this.addColumnStatus) {
                return false;
            }
            if (!this.currentActiveColumnInfo.type) {
                return false;
            }
            
            let fieldOption = this.schemaInfo.fieldOption;
            // 判断原来是否存在
            for (let fieldName in fieldOption) {
                if (fieldName === this.currentActiveColumnInfo.fieldName) {
                    let type = fieldOption[fieldName].type;
                    if (type && type === 'Any') {
                        return false;
                    }
                    return !!type;
                    
                }
            }
        },
        computeSortableValue() {
            return (fieldInfo) => {
                let option = fieldInfo[1];
                if (option.sort) {
                    return 'custom';
                }
                return false;
            };
        },
        computeComponentKey() {
            return key => {
                return this.currentClassEditInfo.columnName + new Date().getTime() + Math.random();
            }
        },
        visibleCustomFieldTypeMap() {
            return Array.from(this.customFieldTypeMap).filter(value => {
                return this.visibleCustomFieldNameList.includes(value[0]);
            });
        }
    },
    watch: {
        '$route.params': {
            handler(newParams, oldParams) {
                if (!oldParams) {
                    return;
                }
                if (newParams.appId === oldParams.appId && newParams.className === oldParams.className) {
                    return;
                }
                this.handleRouteChange();
            },
            deep: true
        }
    },
    created() {
        this.sortableTypeSet.add('Date');
        this.sortableTypeSet.add('Number');
        
        this.setInitValue();
        this.initData();
    },
    beforeDestroy() {
    
    },
    methods: {
        setInitValue() {
            this.queryParams.appId = undefined;
            this.queryParams.className = undefined;
            if (this.$route.params.appId && this.$route.params.appId.indexOf('undefined') === -1) {
                this.queryParams.appId = this.$route.params.appId;
            }
            if (this.$route.params.className && this.$route.params.className.indexOf('undefined') === -1) {
                this.queryParams.className = this.$route.params.className;
            }
            if (!this.queryParams.appId) {
                message.error('请选择应用!');
                this.$router.push(`/storage-application`);
                return;
            }
            if (!this.queryParams.className) {
                message.error('请选择Class!');
                this.$router.push(`/storage-application`);
                return;
            }
            this.getList();
        },
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum;
            this.reloadData();
        },
        handleSizeChange(size) {
            this.queryParams.pageSize = size;
            this.queryParams.pageNum = 1;
            this.reloadData();
        },
        async handleSortChange({ column, prop, order }) {
            let sortSqlList = [];
            await pageUtil.handleSortChange(prop, order, sortSqlList);
            this.queryParams.pageNum = 1;
            this.queryParams.pageSize = 15;
            this.queryParams.order = sortSqlList.map(t => {
                let arr = t.split(' ');
                if ('DESC' === arr[1]) {
                    return `-${arr[0]}`;
                }
                return arr[0];
            }).join(',');
            this.reloadData();
        },
        initData() {
        
        },
        handleRouteChange() {
            this.queryParams.pageSize = 15;
            this.queryParams.pageNum = 1;
            this.queryParams.order = undefined;
            this.queryParams.where = undefined;
            this.queryParams.excludeKeys = undefined;
            this.multiSelectIdList = [];
            this.openFieldVisibleSetting = false;
            this.openConditionQuery = false;
            this.setInitValue();
        },
        reloadData() {
            this.classDataList = [];
            this.queryParams.skip = this.queryParams.pageNum - 1;
            this.queryParams.limit = this.queryParams.pageSize;
            this.loading = true;
            this.apiFunction.queryList(this.queryParams, this.queryParams.appId, this.queryParams.className).then(result => {
                if (result.code === 200) {
                    if (result.data && result.data.results) {
                        this.classDataList = result.data.results;
                        this.queryParams.resultTotal = result.data.count;
                    }
                }
                this.openConditionQuery = false;
                this.loading = false;
            });
        },
        async getList() {
            this.allFieldType = {
                objectId: {
                    type: 'String'
                },
                ACL: {
                    type: 'ACL'
                },
                createUserId: {
                    type: 'String'
                },
                updateUserId: {
                    type: 'String'
                },
                createdAt: {
                    type: 'Date'
                },
                updatedAt: {
                    type: 'Date'
                }
            };
            this.queryParams.skip = this.queryParams.pageNum - 1;
            this.queryParams.limit = this.queryParams.pageSize;
            this.loading = true;
            this.customFieldTypeMap = new Map;
            let customFieldTypeMap = new Map;
            let currentAppId = this.queryParams.appId;
            let currentClassName = this.queryParams.className;
            let currentQueryParams = deepCopy(this.queryParams);
            let visibleCustomFieldIdentity = `${this.queryParams.appId}:${this.queryParams.className}`;
            if (this.visibleCustomFieldIdentity !== visibleCustomFieldIdentity) {
                this.visibleCustomFieldIdentity = visibleCustomFieldIdentity;
                this.visibleCustomFieldNameList = [];
                this.hasInitVisibleCustomField = false;
            }
            
            let result = await this.apiFunction.queryList(currentQueryParams, currentAppId, currentClassName);
            if (currentAppId !== this.queryParams.appId || currentClassName !== this.queryParams.className) {
                return;
            }
            if (result.code === 200) {
                if (result.data && result.data.results) {
                    this.classDataList = result.data.results;
                    this.queryParams.resultTotal = result.data.count;
                }
            }
            
            // 查询schema信息
            storageSchemaApi.querySingleSchema(currentClassName, currentAppId).then(result => {
                if (currentAppId !== this.queryParams.appId || currentClassName !== this.queryParams.className) {
                    return;
                }
                if (result.code === 200) {
                    this.schemaInfo = result.data;
                    
                    this.versionEnableStatus = this.schemaInfo && this.schemaInfo.metadata && this.schemaInfo.metadata['optimisticLockStatus'];
                    
                    let fieldOptions = result.data.fieldOption;
                    if (this.schemaInfo.metadata && this.schemaInfo.metadata.default_acp) {
                        this.defaultACL.setDefaultACL = result.data.metadata.default_acp;
                    }
                    
                    if (!fieldOptions || Object.keys(fieldOptions).length === 0) {
                        this.syncVisibleCustomFieldNameList();
                        this.queryFieldType = deepCopy(this.allFieldType);
                        delete this.queryFieldType.ACL;
                        this.loading = false;
                    } else {
                        let keyArr = Object.keys(fieldOptions);
                        keyArr.forEach((key) => {
                            if (customFieldTypeMap.has(key)) {
                                return;
                            }
                            if (this.baseFieldNameList.includes(key)) {
                                return;
                            }
                            
                            let fieldType = fieldOptions[key]['type'];
                            let require = fieldOptions[key]['required'];
                            let description = fieldOptions[key]['description'];
                            this.allFieldType[key] = {
                                type: fieldType
                            };
                            customFieldTypeMap.set(key, {
                                type: fieldType,
                                sort: this.sortableTypeSet.has(fieldType),
                                require: require,
                                description: description
                            });
                        });
                        this.customFieldTypeMap = customFieldTypeMap;
                        this.syncVisibleCustomFieldNameList();
                        this.loading = false;
                        this.queryFieldType = deepCopy(this.allFieldType);
                        delete this.queryFieldType.ACL;
                    }
                } else {
                    this.loading = false;
                }
                applicationCredentialApi.queryByAppId({ appId: currentAppId }).then(result => {
                    if (currentAppId !== this.queryParams.appId || currentClassName !== this.queryParams.className) {
                        return;
                    }
                    if (result.code === 200) {
                        this.applicationConfig = result.data;
                    }
                });
            });
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.getList();
            this.resetReportSetting();
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.openConditionQuery = true;
        },
        handleOpenFieldVisibleSetting() {
            this.syncVisibleCustomFieldNameList();
            this.openFieldVisibleSetting = true;
        },
        getAllCustomFieldNameList() {
            return Array.from(this.customFieldTypeMap).map(value => value[0]);
        },
        syncVisibleCustomFieldNameList() {
            let allFieldNameList = this.getAllCustomFieldNameList();
            if (!this.hasInitVisibleCustomField) {
                this.visibleCustomFieldNameList = allFieldNameList;
                this.hasInitVisibleCustomField = true;
                return;
            }
            this.visibleCustomFieldNameList = this.visibleCustomFieldNameList.filter(fieldName => {
                return allFieldNameList.includes(fieldName);
            });
        },
        handleSelectAllVisibleField() {
            this.visibleCustomFieldNameList = this.getAllCustomFieldNameList();
        },
        handleInvertVisibleField() {
            let selectedFieldNameSet = new Set(this.visibleCustomFieldNameList);
            this.visibleCustomFieldNameList = this.getAllCustomFieldNameList().filter(fieldName => {
                return !selectedFieldNameSet.has(fieldName);
            });
        },
        handleClearVisibleField() {
            this.visibleCustomFieldNameList = [];
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams.pageSize = 15;
            this.queryParams.pageNum = 1;
            this.queryParams.order = undefined;
            this.queryParams.where = undefined;
            this.queryParams.excludeKeys = undefined;
            this.reloadData();
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.multiSelectIdList = selection.map(item => item.objectId);
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.openAddData = true;
            this.currentSelectDataInfo = {
                addACL: {
                    read: {},
                    write: {}
                },
                ACL: {}
            };
        },
        handleAddColumn() {
            this.openColumnEdit = true;
            this.addColumnStatus = true;
            this.currentActiveColumnInfo = {};
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.currentReportSetting = row;
            this.open = true;
            this.updateStatus = true;
            this.title = '修改事件报表设置';
            this.setReportSettingParam(row);
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            let obj = this;
            this.$modal.confirm('删除"' + row.objectId + '"的数据?').then(function() {
                return obj.apiFunction.delete(row.objectId, obj.queryParams.appId, obj.queryParams.className);
            }).then((result) => {
                if (result.code === 200) {
                    message.success(result.message);
                    obj.reloadData();
                }
            }).catch(() => {
            });
        },
        /** 提交按钮 */
        submitForm: function() {
            this.packageReportSetting(this.updateOrAddReportSetting);
        },
        
        dblClickRow(row, column, event) {
            let columnLabel = column.label;
            let fieldType = this.allFieldType[columnLabel];
            let editValue = row[columnLabel];
            
            if ('_version' === columnLabel) {
                this.currentClassEditInfo.columnName = columnLabel;
                this.currentClassEditInfo.value = editValue;
                this.currentClassEditInfo.fileOption = {
                    type: 'Number'
                };
                this.openClassDataEdit = true;
            } else {
                if (!this.baseFieldNameList.includes(columnLabel)) {
                    this.currentClassEditInfo.columnName = columnLabel;
                    this.currentClassEditInfo.value = editValue;
                    this.currentClassEditInfo.fileOption = fieldType;
                    this.openClassDataEdit = true;
                }
            }
        },
        clickRow(row, column, event) {
            this.currentClassDataInfo = deepCopy(row);
            let columnLabel = column.label;
            if (columnLabel === 'objectId') {
                this.openClassDataDetail = true;
            }
        },
        
        getEditedColumnValue(newColumnValue) {
            let editColumnName = this.currentClassEditInfo.columnName;
            this.currentClassDataInfo[editColumnName] = newColumnValue;
        },
        
        executeUpdateSubmit() {
            // 获取当前编辑的字段名
            // 只对该字段名进行更新
            let editingColumnName = this.currentClassEditInfo.columnName;
            
            // 当前更新的新值
            let newValue = this.currentClassDataInfo[editingColumnName];
            
            let editData = {};
            editData[editingColumnName] = newValue;
            this.apiFunction.update(this.currentClassDataInfo.objectId, editData, this.queryParams.appId, this.queryParams.className).then(result => {
                if (result.code === 200) {
                    this.openClassDataEdit = false;
                    this.reloadData();
                }
            });
            
        },
        executeUpdateCancel() {
            this.currentClassEditInfo = {
                fileOption: {},
                value: undefined,
                columnName: undefined
            };
            this.openClassDataEdit = false;
            this.reloadData();
        },
        
        handleBatchDelete() {
            this.openBatchDeleteData = true;
        },
        executeBatchDelete() {
            let batchDelete = {
                requests: []
            };
            this.multiSelectIdList.forEach((objectId, index) => {
                let singleDelete = {
                    method: 'DELETE',
                    path: `/cloud-storage/1.1/classes/${this.queryParams.className}/${objectId}`
                };
                batchDelete.requests.push(singleDelete);
                if (index === this.multiSelectIdList.length - 1) {
                    storageClassApi.batch(batchDelete, this.queryParams.appId).then(result => {
                        if (result.code === 200) {
                            message.success('批量删除成功!');
                            this.reloadData();
                            this.openBatchDeleteData = false;
                        }
                    });
                }
            });
        },
        async handleGetFilterCondition(condition) {
            this.queryParams.pageNum = 1;
            this.queryParams.where = encodeURIComponent(JSON.stringify(condition));
            this.reloadData();
        },
        handleGetAddDataFieldValue(value, fieldName) {
            this.currentSelectDataInfo[fieldName] = value;
        },
        handleSetAddDataACL(accessInfo) {
            packageACLInfo(accessInfo).then(acl => {
                this.currentSelectDataInfo.ACL = acl;
            });
        },
        executeAddData() {
            let addData = deepCopy(this.currentSelectDataInfo);
            delete addData.addACL;
            if (addData.ACL && Object.keys(addData.ACL).length === 0) {
                delete addData.ACL;
            }
            this.apiFunction.create(addData, this.queryParams.appId, this.queryParams.className).then(result => {
                console.log(result);
                if (result.code === 200) {
                    message.success(result.message);
                    this.openAddData = false;
                    this.reloadData();
                }
            });
        },
        handleGetColumnDefaultValue(value) {
            this.currentActiveColumnInfo.defaultValue = value;
        },
        handleRemoveDefaultValue() {
            this.currentActiveColumnInfo.defaultValue = undefined;
        },
        handleCreateColumn() {
            if (!this.currentActiveColumnInfo.editFieldName) {
                message.error('字段名不能为空!');
                return;
            }
            if (!this.currentActiveColumnInfo.type) {
                message.error('字段类型不能为空!');
                return;
            }
            let schema = deepCopy(this.schemaInfo);
            // 判断是否已经存在
            let fieldOption = schema.fieldOption;
            if (!fieldOption) {
                fieldOption = {};
            }
            
            let isFieldRenameOperation = false
            if (this.addColumnStatus) {
                for (let fieldName in fieldOption) {
                    if (fieldName === this.currentActiveColumnInfo.editFieldName) {
                        message.error('字段已经存在!');
                        return;
                    }
                }
                
                this.currentActiveColumnInfo.fieldName = this.currentActiveColumnInfo.editFieldName
            }else {
                // 处理重命名
                if (this.currentActiveColumnInfo.editFieldName !== this.currentActiveColumnInfo.fieldName) {
                    let newFieldName = this.currentActiveColumnInfo.editFieldName
                    let oldFieldName = this.currentActiveColumnInfo.fieldName
                    
                    schema.renameField = {
                        originalFieldName: oldFieldName,
                        renameFieldName: newFieldName
                    }
                    isFieldRenameOperation = true
                }
            }
            
            fieldOption[this.currentActiveColumnInfo.fieldName] = this.currentActiveColumnInfo;
            schema.fieldOption = fieldOption;
            storageSchemaApi.updateSchema(this.queryParams.className, schema, this.queryParams.appId).then(result => {
                if (result.code === 200) {
                    this.openColumnEdit = false;
                    this.getList();
                    message.success(result.message);
                    
                    if (isFieldRenameOperation) {
                        setTimeout(() => {
                            location.reload(true)
                        }, 50)
                    }
                }
            });
        },
        handleDeleteColumn() {
            let fieldName = this.currentActiveColumnInfo.fieldName
            confirm.error(`是否确定从${this.queryParams.className} 中移除字段 "${fieldName}" ? 字段移除后,Class中该字段的所有数据都将被删除`, "移除字段警告", () => {
                storageSchemaApi.updateSchema(this.queryParams.className, {
                    removeFieldName: fieldName
                }, this.queryParams.appId).then(result => {
                    if (result.code === 200) {
                        this.openColumnEdit = false;
                        message.success(result.message);

                        setTimeout(() => {
                            location.reload(true)
                        }, 50)
                    }
                });
            })
        },
        handleEditColumn(clickFieldName) {
            let schema = deepCopy(this.schemaInfo);
            // 判断是否已经存在
            let fieldOption = schema.fieldOption;
            if (!fieldOption) {
                fieldOption = {};
            }
            for (let fieldName in fieldOption) {
                if (fieldName === clickFieldName) {
                    this.openColumnEdit = true;
                    this.addColumnStatus = false;
                    this.currentActiveColumnInfo = fieldOption[fieldName];
                    this.$set(this.currentActiveColumnInfo, 'editFieldName', fieldName)
                    console.log(this.currentActiveColumnInfo);
                    break;
                }
            }
        },
        async handleSetDataACL(row) {
            let dataACL = row.ACL;
            if (!dataACL) {
                if (this.defaultACL.setDefaultACL) {
                    dataACL = this.defaultACL.setDefaultACL;
                } else {
                    dataACL = this.defaultACL.systemDefaultACL;
                }
            }
            this.currentSetDataACL = await packageACLParam(dataACL);
            this.openSetDataACL = true;
        },
        handleGetDataACL(accessInfo) {
            
            packageACLInfo(accessInfo).then(acl => {
                this.currentClassDataInfo.ACL = acl;
            });
        },
        executeUpdateDataACL() {
            let data = {
                objectId: this.currentClassDataInfo.objectId,
                ACL: this.currentClassDataInfo.ACL
            };
            delete data.ACL._dataCreator;
            this.apiFunction.update(data.objectId, data, this.queryParams.appId, this.queryParams.className).then(result => {
                if (result.code === 200) {
                    this.openSetDataACL = false;
                    this.reloadData();
                }
            });
        },
        handleConfirmDeleteClass() {
            storageSchemaApi.deleteSchema(this.queryParams.className, this.queryParams.appId).then(result => {
                if (result.code === 200) {
                    message.success(result.message);
                    this.$router.push(`/storage-info/${this.queryParams.appId}/data/_User`);
                }
            });
        },
        handleShowUserInfo(userId) {
            if (!userId) {
                return;
            }
            
            cottonUserApi.queryUserCotton({ userId: userId }).then(result => {
                if (result.code === 200) {
                    this.currentShowUserInfo = result.data.result;
                    this.openShowUserInfo = true;
                    this.currentShowUserInfo.forEach(t => {
                        delete t.password;
                        delete t.salt;
                        delete t.phone;
                        delete t.idCardNumber;
                        delete t.showState;
                    });
                }
            });
        },
        handleVersionChange(value) {
            const operate = value ? '开启' : '关闭';
            confirm.error(`是否确认${operate} ${this.queryParams.className} 表的版本号机制`, '版本号', () => {
                let schema = this.schemaInfo;
                schema.enableVersion = value;
                
                storageSchemaApi.updateSchema(this.queryParams.className, schema, this.queryParams.appId).then(result => {
                    if (result.code === 200) {
                        message.success(result.message);
                        
                        setTimeout(() => {
                            location.reload(true);
                        }, 50);
                    }
                });
            }, () => {
                this.versionEnableStatus = !value;
            });
        }
        
    }
};
</script>
<style lang='css'>
.fieldName {
    font-size: 12px;
    color: #303133;
    font-weight: bold;
}

.fieldType {
    margin-left: 5px;
    font-size: 10px;
    color: #909399;
}

.classValue {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

ul, ol {
    margin: 0;
    padding: 0;
    list-style: none;
}

.permissionLi {
    margin-top: 1rem;
    margin-bottom: 1rem;
}

.lineFlex {
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center
}

.fieldVisibleToolbar {
    margin-bottom: 1rem;
}

.fieldVisibleGroup {
    display: flex;
    flex-direction: column;
    max-height: 420px;
    overflow-y: auto;
}

.fieldVisibleItem {
    margin-bottom: .75rem;
}

.fieldDescription {
    margin-left: 8px;
    font-size: 12px;
    color: #606266;
}
</style>
